/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

'use strict';

import Construct from 'can/construct/construct';
import urlUtil from 'scripts/utils/url';

const windowWidth = 950;
const windowHeight = 675;
const liveVideoPopOutUrl = window.globalSettings.pagePaths.liveVideoPopOut;

export default Construct.extend(
    {
        openWindow(videoId) {
            if (!videoId) {
                console.error('Video id is not defined!');
                return;
            }
            window.open(
                this.getLiveUrl(videoId),
                '_blank',
                'width=' +
                    windowWidth +
                    ', height=' +
                    windowHeight +
                    ', top=' +
                    (window.innerHeight - windowHeight) / 2 +
                    ', left=' +
                    (window.innerWidth - windowWidth) / 2,
            );
        },
        openTab(videoId) {
            if (!videoId) {
                console.error('Video id is not defined!');
                return;
            }
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = this.getLiveUrl(videoId);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        getLiveUrl(videoId) {
            return urlUtil.getBaseUrl() + liveVideoPopOutUrl + '#!' + videoId;
        },
    },
    {},
);
